import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

type LegacyTarget = 'instancias' | 'kanban' | 'minhas-tarefas';

function buildDestination(target: LegacyTarget, pathname: string, search: string) {
  if (target !== 'instancias') {
    return `/execucoes/${target}${search}`;
  }

  const params = new URLSearchParams(search);
  const executionId = params.get('executionId');

  if (pathname.startsWith('/workflow') && executionId) {
    params.delete('executionId');
    const nextSearch = params.toString();
    return `/execucoes/instancias/${encodeURIComponent(executionId)}${nextSearch ? `?${nextSearch}` : ''}`;
  }

  return `/execucoes/instancias${search}`;
}

export const LegacyExecutionRedirectPage: React.FC<{ target: LegacyTarget }> = ({ target }) => {
  const location = useLocation();
  const destination = buildDestination(target, location.pathname, location.search);

  return <Navigate to={destination} replace />;
};
